import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  code: string;
  legacyAppId: string;
  erpId: string;
  companyVat: string;
  companyTaxOffice: string;
  imaCode: string;
  contractNo: string;
  contractSignDate: Date;
  contractExpDate: Date;
  aepoNumber: string;
  aepoExpDate: Date;
  hazardousWastePermit: string;
  operationNumber: string;
  insurancePolicyNumber: string;
  insuranceExpirationDate: Date;
  isoExpirationDate: Date;
  nextIsoAuditDate: Date;
  aepoFileId: number;
  hazardousWastePermitFileId: number;
  operationFileId: number;
  insuranceFileId: number;
  isoFileId: number;
  formalName: string;
  addressLine1: string;
  addressLine2: string;
  addressArea: string;
  addressCity: string;
  addressNomos: string;
  postalCode: string;
  regionId: number;
  subregionId: number;
  phone: string;
  mobile: string;
  fax: string;
  contactperson: string;
  email: string;
  email2: string;
  website: string;
  receptionPersonName: string;
  notes: string;
  wasteDestinationTypeId: number;
  collectorId: number;
  recordDate: Date;
  isActive: boolean;
  firstDate: Date;
  lastDate: Date;
  firstUser: string;
  lastUser: string;
  isApproved: boolean;
  approvedBy: string;
  approvedDate: Date;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.code = undefined;
    this.legacyAppId = undefined;
    this.erpId = undefined;
    this.companyVat = undefined;
    this.companyTaxOffice = undefined;
    this.imaCode = undefined;
    this.contractNo = undefined;
    this.contractSignDate = undefined;
    this.contractExpDate = undefined;
    this.aepoNumber = undefined;
    this.aepoExpDate = undefined;
    this.hazardousWastePermit = undefined;
    this.operationNumber = undefined;
    this.insurancePolicyNumber = undefined;
    this.insuranceExpirationDate = undefined;
    this.isoExpirationDate = undefined;
    this.nextIsoAuditDate = undefined;
    this.aepoFileId = undefined;
    this.hazardousWastePermitFileId = undefined;
    this.operationFileId = undefined;
    this.insuranceFileId = undefined;
    this.isoFileId = undefined;
    this.formalName = undefined;
    this.addressLine1 = undefined;
    this.addressLine2 = undefined;
    this.addressArea = undefined;
    this.addressCity = undefined;
    this.addressNomos = undefined;
    this.postalCode = undefined;
    this.regionId = undefined;
    this.subregionId = undefined;
    this.phone = undefined;
    this.mobile = undefined;
    this.fax = undefined;
    this.contactperson = undefined;
    this.email = undefined;
    this.email2 = undefined;
    this.website = undefined;
    this.receptionPersonName = undefined;
    this.notes = undefined;
    this.wasteDestinationTypeId = undefined;
    this.collectorId = undefined;
    this.recordDate = undefined;
    this.isActive = undefined;
    this.firstDate = undefined;
    this.lastDate = undefined;
    this.firstUser = undefined;
    this.lastUser = undefined;
    this.isApproved = undefined;
    this.approvedBy = undefined;
    this.approvedDate = undefined;
  }
}

export const gqlGetQuery = gql`
  query getWastereceptionpoints($limit: Int, $offset: Int, $order: String, $where: String) {
    getWastereceptionpoints(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        code
        companyVat
        companyTaxOffice
        imaCode
        contractNo
        contractSignDate
        contractExpDate
        formalName
        addressLine1
        addressLine2
        addressArea
        addressCity
        addressNomos
        postalCode
        regionId
        phone
        mobile
        fax
        contactperson
        email
        email2
        website
        receptionPersonName
        notes
        wasteDestinationTypeId
        collectorId
        legacyAppId
        erpId
        recordDate
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
        wastedestinationtype {
          id
          name
        }
        collector {
          id
          name
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getWastereceptionpointById($id: Int) {
    getWastereceptionpointById(id: $id) {
      id
      name
      code
      companyVat
      companyTaxOffice
      imaCode
      contractNo
      contractSignDate
      contractExpDate
      aepoNumber
      aepoExpDate
      hazardousWastePermit
      operationNumber
      insurancePolicyNumber
      insuranceExpirationDate
      isoExpirationDate
      nextIsoAuditDate
      aepoFileId
      hazardousWastePermitFileId
      operationFileId
      insuranceFileId
      isoFileId
      formalName
      addressLine1
      addressLine2
      addressArea
      addressCity
      addressNomos
      postalCode
      regionId
      region {
        id
        name
      }
      subregionId
      subregion {
        id
        name
      }
      phone
      mobile
      fax
      contactperson
      email
      email2
      website
      receptionPersonName
      notes
      isApproved
      approvedBy
      approvedDate
      wasteDestinationTypeId
      collectorId
      legacyAppId
      erpId
      recordDate
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      wastedestinationtype {
        id
        name
      }
      collector {
        id
        name
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addWastereceptionpoint($data: WastereceptionpointInput) {
    addWastereceptionpoint(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateWastereceptionpoint($data: WastereceptionpointInput) {
    updateWastereceptionpoint(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteWastereceptionpoint($id: Int) {
    deleteWastereceptionpoint(id: $id)
  }
`;

export const gqlAccept = gql`
  mutation acceptWastereceptionpoint($id: Int) {
    acceptWastereceptionpoint(id: $id)
  }
`;
